// import React from 'react'
// import loginsignupImage from "../asset/login-animation.gif"
// import {Link} from "react-router"
// import { useState } from 'react'
// import {toast} from "react-hot-toast"
// import { useNavigate } from 'react-router'
// import { useDispatch, useSelector } from 'react-redux'
// import { loginRedux } from "../redux/userSlice"
// const Login=()=> {

//   const [data, setData]= useState({
//     email: "",
//     password: "",
//   });

//   const navigate= useNavigate()

//   const userData= useSelector(state=> state)
//   // console.log(userData.user)

//   const dispatch= useDispatch()

// const handleOnChange= (e)=> {
//     const {name, value}= e.target
//     setData((preve)=>{
//         return {
//             ...preve,
//             [name]: value
//         }
//     })
// }

// const handleSubmit= async (e)=>{
//     e.preventDefault()
//     const {email, password}= data

//     if(email && password){
//       const fetchData= await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/login`,{
//         method: "POST",
//         headers:{
//             "content-type": "application/json"
//         },
//         body: JSON.stringify(data)
//     })

//       const dataRes= await fetchData.json()
//       // console.log(dataRes)
//       toast(userData.user.firstName + dataRes.message)

//       if(dataRes.alert){
//         dispatch(loginRedux(dataRes))
//         setTimeout(()=>{
//           navigate("/")
//         }, 1000);
//       }

//       // console.log(userData)
//     }
//     else{
//         alert("Please enter required field")
//     }
// }


//   return (
//     <div className='p-3 md:p-4'>
//         <div className='w-full max-w-sm bg-white m-auto flex flex-col p-4'>
//             {/* <h1 className='text-center text-2xl font-bold'>Sign up</h1> */}
//             <div className='w-20 overflow-hidden rounded-full drop-shadow-md shadow-md m-auto flex item-center'>
//                 <img src= {loginsignupImage} alt='loginsignupImage' className='w-full'/>
//             </div>

//             <form className='w-full py-3 flex flex-col'onSubmit= {handleSubmit}>
            

//                 <label htmlFor= 'email'>Email</label>
//                 <input type= {"email"} id="email" name='email' className= 'mt-1 mb-2 w-full bg-slate-200 px-2 py-1 rounded focus-within:outline-blue-300' 
//                 value= {data.email}
//                 onChange= {handleOnChange}
//                 />
                
//                 <label htmlFor= 'password'>Password</label>
//                 <input type= {"password"} id="password" name= 'password' className= 'mt-1 mb-2 w-full bg-slate-200  px-2 py-1 rounded focus-within:outline-blue-300'
//                 value= {data.password}
//                 onChange= {handleOnChange}
//                 />
            
            
//                 <button className= " w-full max-w-[150px] m-auto bg-red-500 hover:bg-red-600 cursor-pointer text-white text-xl font-medium text-center py-1 rounded-full mt-4">
//                     Login
//                 </button>
//               </form>

//               <p className='text-left text-sm mt-2'>Don't have account ? <Link to={"/signup"} className='text-red-500 underline'>Signup</Link></p>
//         </div>
//     </div>
//   )
// }

// export default Login


import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { toast } from 'react-hot-toast';
import { loginRedux } from '../redux/userSlice';

import { BsLightningChargeFill } from 'react-icons/bs';
import { HiOutlineMail, HiOutlineLockClosed } from 'react-icons/hi';

export default function Login() {
  const [data, setData]       = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate  = useNavigate();
  const dispatch  = useDispatch();

  const handle = (e) =>
    setData(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!data.email || !data.password) { toast.error('Fill in all fields'); return; }
    setLoading(true);
    try {
      const res  = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/login`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(data),
      });
      const json = await res.json();
      if (json.alert) {
        dispatch(loginRedux(json));
        toast.success(json.message);
        setTimeout(() => navigate('/'), 700);
      } else {
        toast.error(json.message);
      }
    } catch { toast.error('Something went wrong'); }
    finally   { setLoading(false); }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{
        background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 100%)',
      }}
    >
      {/* Background blobs */}
      <div className="pointer-events-none absolute"
           style={{ top: '20%', left: '20%', width: 500, height: 500,
             background: 'radial-gradient(circle, rgba(99,102,241,0.10) 0%, transparent 70%)',
             filter: 'blur(80px)' }} />
      <div className="pointer-events-none absolute"
           style={{ bottom: '10%', right: '10%', width: 400, height: 400,
             background: 'radial-gradient(circle, rgba(0,255,240,0.06) 0%, transparent 70%)',
             filter: 'blur(100px)' }} />

      {/* Card */}
      <div
        className="glass-hi rounded-3xl w-full max-w-sm overflow-hidden animate-scale-up"
        style={{ border: '1px solid var(--glass-border-h)' }}
      >
        {/* Top accent */}
        <div style={{ height: 3, background: 'var(--grad-brand)' }} />

        <div className="p-8">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center animate-pulse-glow"
              style={{ background: 'var(--indigo-dim)', border: '1px solid rgba(99,102,241,0.3)' }}
            >
              <BsLightningChargeFill className="text-2xl" style={{ color: 'var(--cyan)' }} />
            </div>
          </div>

          <h1 className="font-display text-2xl font-bold text-center mb-1"
              style={{ color: 'var(--text-primary)' }}>
            WELCOME BACK
          </h1>
          <p className="text-center text-xs font-mono mb-8" style={{ color: 'var(--text-muted)' }}>
            Sign in to your account
          </p>

          <form onSubmit={submit} className="flex flex-col gap-4">
            {/* Email */}
            <div>
              <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                     style={{ color: 'var(--text-muted)' }}>
                Email
              </label>
              <div className="relative">
                <HiOutlineMail
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-lg pointer-events-none"
                  style={{ color: 'var(--text-muted)' }}
                />
                <input
                  type="email" name="email" autoComplete="email"
                  placeholder="you@example.com"
                  className="input-glass pl-10 pr-4 py-3 rounded-xl"
                  value={data.email} onChange={handle}
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                     style={{ color: 'var(--text-muted)' }}>
                Password
              </label>
              <div className="relative">
                <HiOutlineLockClosed
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-lg pointer-events-none"
                  style={{ color: 'var(--text-muted)' }}
                />
                <input
                  type="password" name="password" autoComplete="current-password"
                  placeholder="••••••••"
                  className="input-glass pl-10 pr-4 py-3 rounded-xl"
                  value={data.password} onChange={handle}
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary py-3.5 rounded-xl mt-2 flex items-center justify-center gap-2"
            >
              {loading ? (
                <span
                  className="w-4 h-4 rounded-full border-2 animate-spin"
                  style={{ borderColor: 'rgba(0,0,0,0.2)', borderTopColor: '#000' }}
                />
              ) : (
                <><BsLightningChargeFill /> Login</>
              )}
            </button>
          </form>

          <p className="text-center text-xs mt-6" style={{ color: 'var(--text-muted)' }}>
            No account?{' '}
            <Link to="/signup" className="font-semibold hover:underline"
                  style={{ color: 'var(--indigo-light)' }}>
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}